var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasicDetailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basic_Detail_Icon",
    "data-name": "Basic Detail Icon",
    transform: "translate(-16902 431)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2027",
    "data-name": "Rectangle 2027",
    transform: "translate(16902 -431)",
    fill: "#f5f5f5",
    stroke: "#f5f5f5",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3755",
    "data-name": "Group 3755"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13205",
    "data-name": "Path 13205",
    d: "M8.133,0H0",
    transform: "translate(16929.867 -412.569)",
    fill: "none",
    stroke: "#3d7dc9",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13207",
    "data-name": "Path 13207",
    d: "M3.479,0H0",
    transform: "translate(16929.867 -419)",
    fill: "none",
    stroke: "#3d7dc9",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13210",
    "data-name": "Path 13210",
    d: "M20.934,22.334V19.889A5.116,5.116,0,0,0,15.618,15h-9.3A5.116,5.116,0,0,0,1,19.889v2.445",
    transform: "translate(16913 -417.334)",
    fill: "none",
    stroke: "#3d7dc9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_418",
    "data-name": "Ellipse 418",
    cx: 4.324,
    cy: 4.37,
    rx: 4.324,
    ry: 4.37,
    transform: "translate(16919.297 -414.876)",
    fill: "none",
    stroke: "#3d7dc9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13211",
    "data-name": "Path 13211",
    d: "M5.84,0H0",
    transform: "translate(16929.867 -415.785)",
    fill: "none",
    stroke: "#3d7dc9",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicDetailIcon);
export default __webpack_public_path__ + "static/media/basic-detail-icon.2bc2dac384883c3d39158c61f326fa0f.svg";
export { ForwardRef as ReactComponent };